import React from 'react';
import { useTranslation } from 'react-i18next';

const ThemeToggle = ({ theme, onToggle }) => {
  const { t } = useTranslation();
  return (
    <button
      onClick={onToggle}
      style={{
        padding: '8px 14px', borderRadius: '10px',
        background: 'var(--bg-card)', border: '1px solid var(--border-color)',
        color: 'var(--text-secondary)', fontSize: '16px', cursor: 'pointer',
        display: 'flex', alignItems: 'center', gap: '6px', fontFamily: 'inherit',
        transition: 'all 0.2s ease', boxShadow: 'var(--shadow)'
      }}
      title={theme === 'light' ? t('theme.switchToDark') : t('theme.switchToLight')}
    >
      {theme === 'light' ? '🌙' : '☀️'}
    </button>
  );
};

export default ThemeToggle;
